// ** react imports
import React from 'react';

// ** router imports
import { useSearchParams } from 'react-router-dom';

// ** tabs imports
import CustomerBasicInfo from './Tabs/CustomerBasicInfo';
import CustomerTaxFiles from './Tabs/CustomerTaxFiles';
import CustomerTaxFileHistory from './Tabs/CustomerTaxFileHistory';

const CustomerPanel = () => {
  // hooks
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page') || 'profile';

  switch (page) {
    case 'profile':
      return <CustomerBasicInfo />;
    case 'tax-files':
      return <CustomerTaxFiles />;
    case 'tax-file-history':
      return <CustomerTaxFileHistory />;
    default:
      return <CustomerBasicInfo />;
  }
};

export default CustomerPanel;
